import React from 'react'

const alertText = illinois => {
  let text = 'Show Chicago Resident Discount'
  if (illinois) {
    text = 'Show IL Resident Discount'
  }
  return text
}

function IllinoisOptions({ illinoisChecked, illinois, show, toggle }) {
  if (!show) {
    return null
  }

  return (
    <div className="yellow-bordered-content">
      <h3 className="cta-label">
        {alertText(illinois)}
      </h3>
      <div className="flex">
        <label
          htmlFor="illinois-resident-pricing"
          className="checkbox"
          data-testid="illinois-resident-check-label"
        >
          <input
            type="checkbox"
            checked={illinoisChecked}
            onChange={toggle}
            id="illinois-resident-pricing"
          />
          <span>Each adult must present their ID upon entry for discount.{' '}
          {illinois ? (
            <span>
              &nbsp;A $5 convenience fee applies to all online orders. Reserve tickets without a fee by calling 312-939-2438.
            </span>
          ) : (
            ''
          )}
          </span>
        </label>
      </div>
    </div>
  )
}

export default IllinoisOptions
